function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TimerVerticalTabsDesktopComponent from "segments/desktop/core-components/vertical-timer-tabs/components/timer-vertical-tabs-desktop/timer-vertical-tabs-desktop-component";
import ProductTabTitle from "segments/desktop/tabs/layouts/products-horizontal-timer-tabs/product-tab-title/product-tab-title";
import { WORK_MANAGEMENT_PRODUCT_ID, CRM_PRODUCT_ID, DEV_PRODUCT_ID } from "constants/products";
import { BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME, CRM_DARKER_TINT_02_COLOR_NAME, DEV_DARKER_TINT_02_COLOR_NAME } from "styles/color-consts";
import { useState } from "react";
import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import { StyledProductsHorizontalTimerTabsComponent } from "./products-horizontal-timer-tabs-component.scss";
import DefaultProps from "./default-props";
import ProductTabContentComponent from "./product-tab-content/product-tab-content-component";
const PRODUCT_COLORS_NAMES = {
    [WORK_MANAGEMENT_PRODUCT_ID]: BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
    [CRM_PRODUCT_ID]: CRM_DARKER_TINT_02_COLOR_NAME,
    [DEV_PRODUCT_ID]: DEV_DARKER_TINT_02_COLOR_NAME
};
const ProductsHorizontalTimerTabsComponent = (_param)=>{
    var { tabsTitle, contentRenderer, overrideTabs, progressbarColor, renderDesktopTabsOnly } = _param, verticalTimerTabsProps = _object_without_properties(_param, [
        "tabsTitle",
        "contentRenderer",
        "overrideTabs",
        "progressbarColor",
        "renderDesktopTabsOnly"
    ]);
    const [currentProduct, setCurrentProduct] = useState();
    const title = {
        lineHeight: "100%"
    };
    const rightSideRenderer = (currentTab)=>{
        // this renders the tab's content
        return /*#__PURE__*/ _jsx(ProductTabContentComponent, {
            content: currentTab.tabContent,
            productType: currentTab.productType
        });
    };
    const tabTitleRenderer = (tabTitle, { isSelected })=>{
        if (!tabTitle) return null;
        return /*#__PURE__*/ _jsx(ProductTabTitle, _object_spread_props(_object_spread({}, tabTitle), {
            isSelected: isSelected
        }));
    };
    const onTabChangedHandler = (newTab)=>{
        setCurrentProduct(newTab.productType);
    };
    const getTabsProps = ()=>{
        return overrideTabs || verticalTimerTabsProps;
    };
    const getProgressBarColor = ()=>{
        return progressbarColor || PRODUCT_COLORS_NAMES[currentProduct] || PRODUCT_COLORS_NAMES[WORK_MANAGEMENT_PRODUCT_ID];
    };
    return /*#__PURE__*/ _jsxs(StyledProductsHorizontalTimerTabsComponent, {
        className: "products-horizontal-timer-tabs-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "product-tabs-title-container",
                style: {
                    marginBottom: tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.titleMarginBottom
                },
                children: tabsTitle === null || tabsTitle === void 0 ? void 0 : tabsTitle.titleText
            }),
            !renderDesktopTabsOnly && /*#__PURE__*/ _jsx(VerticalTimerTabs, _object_spread_props(_object_spread({
                tabTitleRenderer: tabTitleRenderer,
                rightSideRenderer: contentRenderer || rightSideRenderer,
                onTabChangedHandler: onTabChangedHandler,
                progressbarColor: getProgressBarColor(),
                title: title,
                getTabIdentifier: (tab)=>tab.productType
            }, tabsTitle, verticalTimerTabsProps), {
                tabs: getTabsProps()
            })),
            renderDesktopTabsOnly && /*#__PURE__*/ _jsx(TimerVerticalTabsDesktopComponent, _object_spread_props(_object_spread({
                tabTitleRenderer: tabTitleRenderer,
                rightSideRenderer: contentRenderer || rightSideRenderer,
                onTabChangedHandler: onTabChangedHandler,
                progressbarColor: getProgressBarColor(),
                title: title,
                getTabIdentifier: (tab)=>tab.productType
            }, tabsTitle, verticalTimerTabsProps), {
                tabs: getTabsProps()
            }))
        ]
    });
};
ProductsHorizontalTimerTabsComponent.defaultProps = DefaultProps;
export default ProductsHorizontalTimerTabsComponent;
